import { render, staticRenderFns } from "./RegistrationNotifications.vue?vue&type=template&id=41a56ede"
import script from "./RegistrationNotifications.vue?vue&type=script&lang=js"
export * from "./RegistrationNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports